export function TypingIndicator() {
	return (
		<div className="m-4 flex-row d-flex typing">
			<div className="blinker-animation border-primary border rounded-circle bg-info" style={{width: "15px", height: "15px"}}/>
			<div className="blinker-animation border-primary border rounded-circle bg-info" style={{width: "15px", height: "15px", "animation-delay": ".2s"}}/>
			<div className="blinker-animation border-primary border rounded-circle bg-info" style={{width: "15px", height: "15px", "animation-delay": ".4s"}}/>
		</div>
	);
}
